<template>
  <div>
    <van-floating-bubble
      v-if="isShow"
      v-model:offset="offset"
      axis="xy"
      class="minimize-room-floating-bubble"
    >
      <div class="minimize-room-box flex v-c" @click="handleToRoom">
        <van-image
          class="poster-img flex-none"
          fit="cover"
          lazy-load
          round
          :src="common.handlePicUrl(anchorInfoStorage.avatar)"
        />
        <div class="info flex-1">
          <div class="otw">{{ roomInfo.title }}</div>
          <div class="otw">{{ anchorInfoStorage.erbanNo }}</div>
        </div>
        <div class="close flex-none flex center" @click.stop="handleQuitRoom">
          <van-icon name="cross" color="#fff" size="12" />
        </div>
      </div>
    </van-floating-bubble>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const roomStore = useRoomStore()
const audioStore = useRoomStore()
const agoraStore = useAgoraStore()
const trtcStore = useTrtcStore()
const { roomInfo, anchorInfoStorage } = storeToRefs(roomStore)

// 控制是否显示最小化
const isShow = computed(() => {
  return (
    roomStore.roomId &&
    route.path.indexOf('/room/') === -1 &&
    roomStore.quitRoomType === 2
  )
})

// floating-bubble 位置
const offset = ref({
  x: document.body.clientWidth / 2 + 40,
  y: document.body.clientHeight - 100
})

/**
 * 进入房间
 */
async function handleToRoom() {
  if (roomStore.roomType === 5 || roomStore.roomType === 9) {
    roomStore.toLiveRoom(
      roomStore.roomId,
      roomStore.roomUid,
      roomStore.roomType
    )
  }
}

/**
 * 退出房间
 */
async function handleQuitRoom() {
  if (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE) {
    switch (roomStore.roomInfo.audioChannel) {
      case 1:
        // 声网
        await agoraStore.leave()
        break
      case 3:
        // 腾讯
        await trtcStore.exit()
        break
    }
  } else {
    switch (roomStore.roomInfo.audioChannel) {
      case 1:
        // 声网
        await agoraStore.leave()
        break
      case 3:
        // 腾讯
        await trtcStore.exit()
        break
    }
  }
  roomStore.setQuitRoomType(1)
  audioStore.resetData()
  roomStore.quit()
}
</script>

<style lang="scss">
.minimize-room-floating-bubble {
  @include wh(120px, 30px);
  background: #ff0036;
  .minimize-room-box {
    width: 100%;
    padding: 0 2px;
  }
  .poster-img {
    @include wh(28px, 28px);
    animation: poster-spin-keyframes 7s linear infinite; /* 动画属性 */
  }
  @keyframes poster-spin-keyframes {
    0% {
      transform: rotate(0deg); /* 初始状态 */
    }
    100% {
      transform: rotate(360deg); /* 旋转到360度 */
    }
  }
  .info {
    overflow: hidden;
    padding: 0 2px;
    @include font-style(12px, #fff);
    .otw {
      width: 100%;
    }
  }
  .close {
    @include wh(20px, 20px);
  }
}
</style>
